import React, { Component } from 'react';
import DefaultLoader from '../components/DefaultLoader';
import DefaultButton from '../components/DefaultButton';
import Colors from '../constants/Colors';
import { Tooltip, IconButton, FormLabel, Stepper, Step, StepLabel } from '@material-ui/core';
import Firestore from '../api/firebase/Firestore';
import brLocale from "date-fns/locale/pt-BR";
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import DefaultModal from '../components/DefaultModal';
import DefaultInput from '../components/DefaultInput';
import SessionHelper from '../helper/SessionHelper';
import moment from 'moment';
import ReceiptIcon from '@material-ui/icons/Receipt';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import RedeemIcon from '@material-ui/icons/Redeem';
import AddIcon from '@material-ui/icons/Add';
import CropFreeIcon from '@material-ui/icons/CropFree';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import MoneyIcon from '@material-ui/icons/Money';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import InputMask from "react-input-mask";
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
import CheckIcon from '@material-ui/icons/CheckCircle';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SaleCard from '../components/SaleCard';
import TicketCard from '../components/TicketCard';
import DefaultSelect from '../components/DefaultSelect';
import TermHelper from '../helper/TermHelper';
import ZipCodeHelper from '../helper/ZipCodeHelper';
import CurrencyHelper from '../helper/CurrencyHelper';
import CurrencyInput from '../components/CurrencyInput';
import { toast } from 'react-toastify';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import InventoryHelper from '../helper/InventoryHelper';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import HeaderActionsWrapper from '../components/HeaderActionsWrapper';

export default class SalesPage extends Component {
    state = {
        addClient: false,
        loadingModal: false,
        addSaleModal: false,
        search: '',
        addSaleData: {
            step: 0,
            steps: ['Cliente', 'Produtos ou Serviços', 'Método de Pagamento', 'Confirmação', 'Finalização'],
            id_user: '',
            items: [],
            payment_method: '',
            value: 0,
            discount: 0,
            name: '',
            email: '',
            phone: '',
            cpf: '',
            zipcode: '',
            street: '',
            number: '',
            neighbourhood: '',
            complement: '',
        },
        statuses: [
            { type: `paid`, color: Colors.success, title: `Pago` },
            { type: `waiting_payment`, color: Colors.danger, title: `Pendente` },
            { type: `late`, color: Colors.error, title: `Atrasado` },
        ],
        selectedStatuses: [],
        openTickets: {},
        end: moment().add(1, 'day').toDate(),
        paginationStart: moment().startOf('month'),
        paginationEnd: moment().endOf('month'),
        paymentOptions: [
            { label: 'Pix', icon: <CropFreeIcon style={styles.paymentIcon} />, key: 'pix' },
            { label: 'Dinheiro', icon: <AttachMoneyIcon style={styles.paymentIcon} />, key: 'money' },
            { label: 'Cartão de Crédito', icon: <CreditCardIcon style={styles.paymentIcon} />, key: 'credit-card' },
            { label: 'Cartão de Débito', icon: <MoneyIcon style={styles.paymentIcon} />, key: 'debit-card' },
            { label: 'Permuta', icon: <SwapHorizIcon style={styles.paymentIcon} />, key: 'permuta' },
            { label: 'Bonificação', icon: <RedeemIcon style={styles.paymentIcon} />, key: 'bonificacao' },
            { label: 'Comanda (Em Débito)', icon: <ReceiptIcon style={styles.paymentIcon} />, key: 'ticket' },
        ],
        ticketsDocs: [],
        productsDocs: [],
        salesDocs: [],
        usersDocs: [],
        adminUsers: [],
        cashierDocs: [],
        cashierLastOperation: null,
        cashierAvailableMoney: null,
        rawCashierAvailableMoney: null,
        cashierWithdraw: null,
        rawCashierWithdraw: null,
        reloading: false,
        loading: true,
        isEditing: false,
    }

    componentDidMount = async () => {
        await this.setState({ loading: true });

        await this.getDocs();

        this.interval = setInterval(() => { if (!this.state.addSaleModal && !this.state.isEditing) this.getDocs() }, 600000);

        await this.setState({ loading: false });
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getDocs = async () => {
        this.setState({ reloading: true });

        await this.getUsers();
        await this.getSystemUsers();
        await this.getProducts();
        await this.getTicketsDocs();
        await this.getSalesDocs();
        await this.getCashierDocs();

        this.setState({ reloading: false });
    }

    getSystemUsers = async () => {
        let query = await Firestore.customQuery('user').where('id_company', '==', SessionHelper.getData().id_company).where('type', '==', 'admin').orderBy('name', 'asc').get();
        let query2 = await Firestore.customQuery('user').where('type', '==', 'super_admin').orderBy('name', 'asc').get();

        let docs = [];

        query.forEach((doc, key) => {
            docs.push({ ...doc.data(), id: doc.id });
        });

        query2.forEach((doc, key) => {
            docs.push({ ...doc.data(), id: doc.id });
        });

        this.setState({ adminUsers: docs });
    }

    getUsers = async () => {
        let query = await Firestore.customQuery('user').where('id_companies', 'array-contains', SessionHelper.getData().id_company).where('type', 'in', ['student', 'sales_user']).orderBy('name', 'asc').get();

        let docs = [];

        query.forEach((doc, key) => {
            let data = doc.data();

            if (data.type == 'student') {
                data.type_label = <div style={{ backgroundColor: Colors.success, ...styles.clientSelectionText }}>{TermHelper.getestablishmentTypeLabel(SessionHelper.getData().company.establishment_type).singular}</div>;
            } else {
                data.type_label = <div style={{ backgroundColor: Colors.primary, ...styles.clientSelectionText }}>Não {TermHelper.getestablishmentTypeLabel(SessionHelper.getData().company.establishment_type).singular}</div>;
            }

            docs.push({ ...data, id: doc.id });
        });

        this.setState({ usersDocs: docs });
    }

    getCashierDocs = async () => {

        let query = await Firestore.customQuery('store_cashier').where('id_company', '==', SessionHelper.getData().id_company).orderBy('date', 'desc').limit(1).get();
        let docs = [];

        query.forEach((doc, key) => {

            let data = doc.data();
            docs.push({ ...data, id: doc.id });
        });

        this.setState({ cashierDocs: docs, cashierLastOperation: docs[0] || { operation: 'close', amount: 0 } });
    }

    getCashierMoneyFromOperation = async () => {

        await this.getTicketsDocs();
        await this.getSalesDocs();

        let lastOperation = this.state.cashierLastOperation;
        let storeDocs = [...this.state.salesDocs, ...this.state.ticketsDocs];
        let cashierAvailableMoney = 0;


        if (lastOperation.operation === 'close') {

            cashierAvailableMoney += lastOperation.amount;

        } else {

            cashierAvailableMoney += lastOperation.amount;

            let referenceDate = moment(lastOperation.date.toDate());

            storeDocs.forEach((sale, key) => {

                if (moment(sale.date.toDate()).isSameOrAfter(referenceDate) && sale.payment_method === 'money') {

                    cashierAvailableMoney += sale.amount;
                }
            });
        }

        this.setState({ rawCashierAvailableMoney: cashierAvailableMoney / 100, cashierAvailableMoney: cashierAvailableMoney / 100 });
    }

    getProducts = async () => {
        let query = await Firestore.customQuery('product').where('id_company', '==', SessionHelper.getData().id_company).where('active', '==', true).orderBy('name', 'asc').get();

        let docs = [];

        query.forEach((doc, key) => {
            let data = doc.data();

            if (data.type == 'product') {
                let stockRule = Colors.danger;

                if (data.quantity_available) {
                    if (data.low_inventory_reminder) {
                        if (data.quantity_available > data.low_inventory_reminder) {
                            stockRule = Colors.danger;
                        }

                        if (data.quantity_available > (data.low_inventory_reminder * 2)) {
                            stockRule = Colors.success;
                        }
                    } else {
                        if (data.quantity_available > 5) {
                            stockRule = Colors.danger;
                        }

                        if (data.quantity_available > 10) {
                            stockRule = Colors.success;
                        }
                    }
                }

                data.type_label = <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ backgroundColor: Colors.primary, ...styles.clientSelectionText }}>Produto</div>
                    <div style={{ backgroundColor: stockRule, ...styles.clientSelectionText }}>{parseInt(data.quantity_available)} em estoque</div>
                    <div style={{ backgroundColor: Colors.success, fontWeight: 'bold', ...styles.clientSelectionText }}>{CurrencyHelper.centsToMoney(data.price)}</div>
                </div>;
            } else {
                data.type_label = <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ backgroundColor: Colors.contrast, ...styles.clientSelectionText }}>Serviço</div>
                    <div style={{ backgroundColor: Colors.success, fontWeight: 'bold', ...styles.clientSelectionText }}>{CurrencyHelper.centsToMoney(data.price)}</div>
                </div>;
            }

            docs.push({ ...data, id: doc.id });
        });

        this.setState({ productsDocs: docs });
    }

    searchArray(array, searchField, keyword) {
        let search = [];

        for (var j = 0; j < array.length; j++) {
            var regex = new RegExp(keyword, "gm");

            if (array[j][searchField].match(regex)) search.push(array[j]);
        }

        return search;
    }

    getTicketsDocs = async () => {
        let query = await Firestore.customQuery('order').where('id_company', '==', SessionHelper.getData().id_company).where('type', '==', 'ticket').where('end', '>=', this.state.paginationStart.toDate()).where('end', '<=', this.state.paginationEnd.toDate()).orderBy('end', 'asc').get();
        let docs = [];

        query.forEach((document, key) => {
            let doc = { ...document.data(), id: document.id };

            let canPush = true;

            if (this.state.search.length > 0 && canPush) {
                let users = this.searchArray(this.state.usersDocs, `name`, this.state.search);

                if (doc.id_user) {
                    canPush = users.some(user => doc.id_user === user.id);
                } else {
                    canPush = false;
                }
            }

            if (this.state.selectedStatuses.length > 0 && canPush) {
                if (doc.end.toDate && moment(doc.end.toDate()).isValid()) {
                    canPush = this.state.selectedStatuses.includes(doc.status);

                    if (doc.status !== `paid`) {
                        if (this.state.selectedStatuses.includes('late') && !this.state.selectedStatuses.includes('waiting_payment')) {
                            if (doc.end.toDate && moment(doc.end.toDate()).isValid()) canPush = moment(doc.end.toDate()).isSameOrBefore(moment());
                        }

                        if (this.state.selectedStatuses.includes('waiting_payment') && !this.state.selectedStatuses.includes('late')) {
                            if (doc.end.toDate && moment(doc.end.toDate()).isValid()) canPush = moment(doc.end.toDate()).isSameOrAfter(moment());
                        }
                    }
                }
            }

            if (doc.canceled) canPush = false;

            if (canPush) docs.push(doc);
        });

        this.setState({ ticketsDocs: docs });
    }

    getSalesDocs = async () => {
        let query = await Firestore.customQuery('order').where('id_company', '==', SessionHelper.getData().id_company).where('type', '==', 'product').where('date', '>=', this.state.paginationStart.toDate()).where('date', '<=', this.state.paginationEnd.toDate()).orderBy('date', 'desc').get();
        let docs = [];

        query.forEach((document, key) => {
            let doc = { ...document.data(), id: document.id };

            let canPush = true;

            if (this.state.search.length > 0 && canPush) {
                let users = this.searchArray(this.state.usersDocs, `name`, this.state.search);

                if (doc.id_user) {
                    canPush = users.some(user => doc.id_user === user.id);
                } else {
                    canPush = false;
                }
            }

            if (doc.canceled) canPush = false;

            if (canPush) docs.push(doc);
        });

        this.setState({ salesDocs: docs });
    }

    renderTickets = () => {
        return (
            <div>
                <div style={styles.kanbanTitleContainer}>
                    <FormLabel style={styles.kanbanTitle}>COMANDAS · {this.state.reloading ? <DefaultLoader size={13} css={{ marginLeft: 6 }} color={`rgba(0, 0, 0, 0.54)`} /> : this.state.ticketsDocs.length}</FormLabel>
                    <div style={{ flexDirection: 'row', display: 'flex', height: 20, marginTop: -4, marginRight: -10 }}>
                        {this.renderStatuses()}
                    </div>
                </div>
                <div style={styles.kanbanCardsContainer}>
                    <ul style={styles.ticketCardsContainer}>
                        {this.state.ticketsDocs.map(doc => <TicketCard onIsEditing={(flag) => { this.setState({ isEditing: flag }) }} fromSalesPage={true} productsDocs={this.state.productsDocs} doc={doc} usersDocs={this.state.usersDocs} adminUsers={this.state.adminUsers} />)}
                    </ul>
                </div>
            </div>
        );
    }

    renderTodaysSales = () => {
        return (
            <div>
                <div style={styles.kanbanTitleContainer}>
                    <FormLabel style={styles.kanbanTitle}>VENDAS · {this.state.reloading ? <DefaultLoader size={13} css={{ marginLeft: 6 }} color={`rgba(0, 0, 0, 0.54)`} /> : this.state.salesDocs.length}</FormLabel>
                </div>
                <div style={styles.kanbanCardsContainer}>
                    {this.state.salesDocs.map(doc => <SaleCard doc={doc} usersDocs={this.state.usersDocs} adminUsers={this.state.adminUsers} />)}
                </div>
            </div>

        );
    }

    getOpenTickets = async (id_user) => {
        let queryOpen = await Firestore.customQuery('order').where('status', '==', 'waiting_payment').where('id_user', '==', id_user).where('end', '>=', new Date()).get();
        let queryLate = await Firestore.customQuery('order').where('status', '==', 'waiting_payment').where('id_user', '==', id_user).where('end', '<=', new Date()).get();

        this.setState({
            openTickets: {
                open: queryOpen.docs.length,
                late: queryLate.docs.length,
            }
        })
    }

    getOrInsertUser = async () => {
        if (this.state.addSaleData.id_user) return this.state.addSaleData.id_user;

        let id_user = await Firestore.getId('user');

        await Firestore.insert({
            name: this.state.addSaleData.name,
            type: "sales_user",
            id_companies: [SessionHelper.getData().id_company],
            created_at: new Date(),
            cpf: this.state.addSaleData.cpf ? this.state.addSaleData.cpf.replace(/[^\d]/g, '') : null,
            email: this.state.addSaleData.email || null,
            phone: this.state.addSaleData.phone ? `${this.state.addSaleData.phone.replace(/[^\d]/g, '')}` : null,
            state: this.state.addSaleData.state || null,
            city: this.state.addSaleData.city || null,
            zipcode: this.state.addSaleData.zipcode ? this.state.addSaleData.zipcode.replace(/[^\d]/g, '') : null,
            street: this.state.addSaleData.street || null,
            number: this.state.addSaleData.number || null,
            neighbourhood: this.state.addSaleData.neighbourhood || null,
            complement: this.state.addSaleData.complement || null
        }, 'user', id_user);

        return id_user;
    }

    insertAndFinish = async () => {
        let success = true;

        this.setState({ loadingModal: true });
        let id_user = await this.getOrInsertUser();

        let orderTitle = `${this.state.addSaleData.payment_method === 'ticket' ? `Comanda` : `Pedido`} #${moment().format('HHmmss')}`;
        let price = parseInt(this.state.addSaleData.value - this.state.addSaleData.discount);

        let order = {
            items: this.state.addSaleData.items,
            date: new Date(),
            title: orderTitle,
            amount: price,
            discount: parseInt(this.state.addSaleData.discount),
            brute_amount: parseInt(this.state.addSaleData.value),
            tax: 0,
            payment_method: this.state.addSaleData.payment_method,
            id_user: id_user,
            type: this.state.addSaleData.payment_method === 'ticket' ? 'ticket' : 'product',
            finished: false,
            refunded: false,
            id_company: SessionHelper.getData().id_company,
            date: new Date(),
            id_transaction_pagarme: null,
            created_by: SessionHelper.getFirebaseAuth().uid,
            status: this.state.addSaleData.payment_method === 'ticket' ? 'waiting_payment' : 'paid',
        };

        if (this.state.addSaleData.payment_method === 'ticket') order.end = this.state.end;

        try {
            await Firestore.insert(order, 'order');

            for (let item of order.items) {
                if (item.tangible) {
                    await InventoryHelper.addProductMovement(item.id, item.quantity, 'exit', orderTitle, false);
                }
            }
        } catch (e) {
            success = false;
        }

        this.setState({ loadingModal: false });

        return success;
    }

    async handleNext() {
        let isValid = true;
        let step = this.state.addSaleData.step;

        this.setState({ loadingModal: true });

        if (step === 0) {
            if (!this.state.addSaleData.name) {
                isValid = false;
                toast.info('Selecione ou crie um cliente.')
            }
        } else if (step === 1) {
            if (this.state.addSaleData.items.length < 1) {
                isValid = false;
                toast.info('Adicione pelo menos um produto a esta venda.')
            } else {
                this.state.addSaleData.items.forEach((item, key) => {
                    if (!item.id) {
                        isValid = false;
                        toast.error(`Produto ou serviço do item ${key + 1} está vazio.`);
                    }
                })
            }
            if (this.state.addSaleData.value < this.state.addSaleData.discount) {
                isValid = false;
                toast.error('Desconto não pode ser maior que valor total');
            }
        } else if (step === 2) {
            if (!this.state.addSaleData.payment_method) {
                isValid = false;
                toast.info('Selecione um método de pagamento');
            }
            if (this.state.addSaleData.payment_method === 'ticket' && !moment(this.state.end).isValid()) {
                isValid = false;
                toast.error('Comanda deve ter uma data máxima de pagamento');
            }
        } else if (step === 3) {
            isValid = await this.insertAndFinish();
            if (!isValid) toast.error('Ocorreu um erro ao finalizar esta venda.');
        } else if (step === 4) {
            isValid = false;
            step = 0;
            this.setState({
                addSaleModal: false,
                end: moment().add(1, 'day').toDate(),
                openTickets: {},
                addClient: false,
                addSaleData: {
                    ...this.state.addSaleData,
                    id_user: '',
                    items: [],
                    payment_method: '',
                    value: 0,
                    discount: 0,
                    name: '',
                    email: '',
                    phone: '',
                    cpf: '',
                    zipcode: '',
                    street: '',
                    number: '',
                    neighbourhood: '',
                    complement: '',
                }
            })
            await this.getDocs();
        }

        if (isValid) { step++ }

        this.setState({ addSaleData: { ...this.state.addSaleData, step }, loadingModal: false })
    };

    saveCashierOperation = async () => {

        let operation = this.state.cashierLastOperation.operation === 'open' ? 'close' : 'open';

        try {

            this.setState({ loadingModal: true });

            let data = {
                operation,
                amount: parseInt(this.state.rawCashierAvailableMoney * 100),
                date: new Date(),
                id_user: SessionHelper.getFirebaseAuth().uid,
                id_company: SessionHelper.getData().id_company,
            };

            await Firestore.insert(data, 'store_cashier');
            await this.getCashierDocs();

            toast.success(`Caixa ${operation === 'open' ? 'aberto' : 'fechado'} com sucesso`)
            this.setState({ loadingModal: false, cashierModal: false });

        } catch (error) {

            this.setState({ loadingModal: false });
            toast.error(`Houve um problema ao ${operation === 'open' ? 'abrir' : 'fechar'} o caixa`);
        }
    }

    withdrawFromCashier = async () => {

        let available = parseInt(this.state.rawCashierAvailableMoney * 100);
        let amount = parseInt(this.state.rawCashierWithdraw * 100);

        if ((available - amount) < 0) {

            toast.warn('Saldo insuficiente');

        } else {

            let lastCashierOperation = this.state.cashierLastOperation;

            try {

                this.setState({ loadingModal: true });

                let withdraws = lastCashierOperation.withdraws || [];
                withdraws.push({ id_user: SessionHelper.getFirebaseAuth().uid, date: new Date(), amount: amount, before_amount: lastCashierOperation.amount, available: parseInt(lastCashierOperation.amount - amount) });

                let update = {
                    amount: parseInt(lastCashierOperation.amount - amount),
                    withdraws,
                };

                await Firestore.update(update, 'store_cashier', lastCashierOperation.id);
                await this.getCashierDocs();

                toast.success(`Valor retirado com sucesso`);
                this.setState({ loadingModal: false, cashierWithdrawModal: false, rawCashierWithdraw: null, cashierWithdraw: null });

            } catch (error) {

                this.setState({ loadingModal: false });
                toast.error(`Houve um problema ao retirar o valor do caixa`);
            }
        }
    }

    handleBack() {
        this.setState({ loadingModal: true });

        let step = this.state.addSaleData.step;
        step--;

        this.setState({ addSaleData: { ...this.state.addSaleData, step }, loadingModal: false });
    };

    renderIcon(step) {
        return (
            <div style={{ backgroundColor: this.state.addSaleData.step < step ? 'lightgrey' : Colors.primary, width: 30, height: 30, padding: 5, fontSize: 14, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ color: '#FFFFFF' }}>{this.state.addSaleData.step < step + 1 ? (step + 1) : <CheckIcon style={{ fontSize: 20, paddingTop: 3 }} />}</div>
            </div>
        )
    }

    async zipCodeFetch(zipCode) {
        if (zipCode.length) {
            let response = await ZipCodeHelper.getAddress(zipCode.replace(/[^\d]/g, ''));

            if (response !== false) {

                this.setState({ addSaleData: { ...this.state.addSaleData, street: response.logradouro, city: response.localidade, state: response.uf, neighbourhood: response.bairro, complement: response.complemento } })

            } else {

                this.setState({ addSaleData: { ...this.state.addSaleData, street: '', city: '', state: '', neighbourhood: '', complement: '' } })
            }
        }
    }

    renderClientForm() {
        if (this.state.addClient) {
            return (
                <div>
                    <div style={{ color: 'orange', display: 'flex', flexDirection: 'row', fontWeight: 'bold', marginBottom: 10 }}>
                        <InfoRoundedIcon style={{ fontSize: 20, marginRight: 8 }} />
                        <div>{'Se o valor for ficar em débito recomendamos que preencha todos os dados'}</div>
                    </div>

                    <DefaultInput required onError={(error, msg) => { this.setState({ inputError: error }) }} onBlur={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, name: v } }) }} label={'Nome'} />
                    <InputMask onBlur={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, cpf: v } }) }} mask="999.999.999-99" maskPlaceholder={''}>
                        <DefaultInput onError={(error, msg) => { this.setState({ inputError: error }) }} hasMask={true} number={true} minLength={11} label={'CPF'} />
                    </InputMask>

                    <DefaultInput email onError={(error, msg) => { this.setState({ inputError: error }) }} onBlur={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, email: v } }) }} label={'E-mail'} />

                    <InputMask onBlur={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, phone: v } }) }} mask="+55 (99) 9 9999-9999" maskPlaceholder={''}>
                        <DefaultInput onError={(error, msg) => { this.setState({ inputError: error }) }} hasMask={true} number={true} minLength={11} label={'Telefone'} />
                    </InputMask>

                    <FormLabel style={{ paddingTop: 28, paddingBottom: 18 }} component="legend">Endereço</FormLabel>
                    <div style={{ color: Colors.contrast, display: 'flex', flexDirection: 'row', fontWeight: 'bold', marginBottom: 10 }}>
                        <InfoRoundedIcon style={{ fontSize: 20, marginRight: 8 }} />
                        <div>{'Informe o CEP para auto-completar o endereço.'}</div>
                    </div>
                    <InputMask onBlur={(v) => { this.zipCodeFetch(v) }} onChange={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, zipcode: v } }) }} mask="99999-999" value={this.state.zipcode}>
                        <DefaultInput onError={(error, msg) => { this.setState({ inputError: error }) }} hasMask={true} number={true} minLength={8} label={'Cep'} />
                    </InputMask>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ width: '50%', paddingRight: 5 }}><DefaultInput value={this.state.addSaleData.state} disabled={true} label={'Estado'} /></div>
                        <div style={{ width: '50%', paddingLeft: 5 }}><DefaultInput value={this.state.addSaleData.city} disabled={true} label={'Cidade'} /></div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ width: '70%', paddingRight: 5 }}><DefaultInput value={this.state.addSaleData.street} onChange={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, street: v } }) }} label={'Rua'} /></div>
                        <div style={{ width: '30%', paddingLeft: 5 }}><DefaultInput value={this.state.addSaleData.number} onChange={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, number: v } }) }} label={'Número'} /></div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ width: '50%', paddingRight: 5 }}><DefaultInput value={this.state.addSaleData.neighbourhood} onChange={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, neighbourhood: v } }) }} label={'Bairro'} /></div>
                        <div style={{ width: '50%', paddingLeft: 5 }}><DefaultInput value={this.state.addSaleData.complement} onChange={(v) => { this.setState({ addSaleData: { ...this.state.addSaleData, complement: v } }) }} label={'Complemento'} /></div>
                    </div>
                    <div style={{ marginTop: 8 }} />
                </div>
            );
        }
    }

    renderClientSelection() {
        return (
            <div>
                <DefaultSelect
                    useCustomRender
                    search={true}
                    searchField={'name'}
                    id={'user_selection'}
                    valueField={'id'}
                    displayField={'name'}
                    secondaryComponent={'type_label'}
                    value={this.state.addSaleData.id_user}
                    onChange={(v) => {
                        let name = ``;

                        let doc = this.state.usersDocs.find(doc => doc.id === v.target.value);

                        if (doc) {
                            name = doc.name;
                            this.getOpenTickets(doc.id);
                        }

                        this.setState({
                            addSaleData: { ...this.state.addSaleData, id_user: v.target.value, name }
                        });
                    }}
                    docs={this.state.usersDocs}
                    label={'Selecione um Cliente Cadastrado'}
                />
                <div style={{ marginTop: 20, marginBottom: 20, fontSize: 20, color: Colors.disabled, width: '100%', textAlign: 'center' }}>ou</div>
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 20 }}>
                    <FormLabel style={{ paddingTop: 10, marginRight: 10 }} component="legend">{`Adicione um cliente`}</FormLabel>
                    <IconButton
                        disabled={this.state.addSaleData.id_user}
                        onClick={() => {
                            if (!this.state.addClient === false) {
                                this.setState({ addSaleData: { ...this.state.addSaleData, name: '', cpf: '', email: '', phone: '', street: '', city: '', state: '', neighbourhood: '', complement: '' } });
                            }
                            this.setState({ addClient: !this.state.addClient })
                        }}
                        style={{ boxShadow: Colors.boxShadow, backgroundColor: this.state.addSaleData.id_user ? Colors.disabled : Colors.primary, height: 32, width: 32, borderRadius: 16, color: '#fff' }}>
                        <AddIcon style={{ transform: this.state.addClient ? 'rotate(45deg)' : 'rotate(0deg)', transition: `.8s ease-in-out` }} />
                    </IconButton>
                </div>
                {this.renderClientForm()}
            </div>
        );
    }

    addProduct() {
        let items = this.state.addSaleData.items;
        items.push({ id: null, quantity: 1, tangible: true, title: ``, unit_price: 0 });

        this.setState({ addSaleData: { ...this.state.addSaleData, items } });
    }

    async updatePrice() {
        let value = 0;

        this.state.addSaleData.items.forEach(item => {
            value += (item.unit_price * item.quantity);
        });

        this.setState({ addSaleData: { ...this.state.addSaleData, value } });
    }

    async handleQuantityChange(increment, key) {
        let items = this.state.addSaleData.items;
        let quantity = items[key].quantity;

        let doc = this.state.productsDocs.find(doc => doc.id === items[key].id);

        let canDoOperation = true;

        if (doc) {
            if (doc.type !== 'service' && increment && (doc.quantity_available < 1 || doc.quantity_available < (quantity + 1))) {
                canDoOperation = false;
            }
        } else {
            canDoOperation = false;
        }

        if (!increment && (quantity - 1) < 1) canDoOperation = false;

        if (canDoOperation) {
            if (increment) {
                quantity++;
            } else {
                quantity--;
            }
        }

        items[key].quantity = quantity;

        await this.setState({ addSaleData: { ...this.state.addSaleData, items } });

        this.updatePrice();
    }

    renderProductSelection() {
        return (
            <div>
                {!this.state.addSaleData.items.length ? <p style={{ color: 'grey' }}>Nenhum produto ou serviço selecionado.</p> : null}

                {

                    this.state.addSaleData.items.map((item, key) => {

                        return (
                            <div style={{ paddingTop: 15, paddingBottom: 15, display: 'flex', flexDirection: 'row', width: '100%', borderBottom: '.5px solid lightgrey', justifyContent: 'space-evenly', alignItems: 'center' }}>

                                <div style={{ paddingRight: 15 }}>
                                    <FormLabel>Quantidade</FormLabel>
                                    <div style={{ display: 'flex', flexDirection: 'row', width: 120, alignItems: 'center' }}>
                                        <Tooltip title={'Remover Unidade'}>
                                            <IconButton style={{ height: 32, width: 32 }} onClick={() => { this.handleQuantityChange(false, key) }}>
                                                <RemoveIcon />
                                            </IconButton>
                                        </Tooltip>
                                        <div style={{ fontSize: 32, margin: 10 }}>{item.quantity}</div>
                                        <Tooltip title={'Adicionar Unidade'}>
                                            <IconButton style={{ height: 32, width: 32 }} onClick={() => { this.handleQuantityChange(true, key) }}>
                                                <AddIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div style={{ width: '60%' }}>
                                    <DefaultSelect
                                        useCustomRender
                                        search={true}
                                        searchField={'name'}
                                        id={'product_selection'}
                                        valueField={'id'}
                                        displayField={'name'}
                                        secondaryComponent={'type_label'}
                                        value={item.id}
                                        onChange={async (v) => {
                                            let itemsSale = this.state.addSaleData.items;
                                            itemsSale[key].id = v.target.value;

                                            let doc = this.state.productsDocs.find(doc => doc.id === v.target.value);

                                            if (doc) {
                                                itemsSale[key] = { id: v.target.value, quantity: 1, tangible: doc.type === 'product', title: doc.name, unit_price: doc.price };
                                            }

                                            await this.setState({ addSaleData: { ...this.state.addSaleData, items: itemsSale } });

                                            this.updatePrice();
                                        }}
                                        docs={this.state.productsDocs}
                                        label={'Selecione os Produtos ou Serviços'}
                                    />
                                </div>
                                <div style={{ width: 10 }} />
                                <Tooltip title={'Remover'}>
                                    <IconButton onClick={() => { let items = this.state.addSaleData.items; items.splice(key, 1); this.setState({ addSaleData: { ...this.state.addSaleData, items } }); this.updatePrice(); }} style={{ boxShadow: Colors.boxShadow, marginLeft: 15, border: '1px solid lightgrey', width: 48, height: 48 }}>
                                        <DeleteIcon style={{ color: Colors.error }} />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        )
                    })

                }

                <Tooltip title={'Adicionar Operador'}>
                    <IconButton onClick={() => { this.addProduct() }} style={{ boxShadow: Colors.boxShadow, border: '1px solid lightgrey', marginTop: 10 }}>
                        <AddIcon style={{ color: Colors.primary }} />
                    </IconButton>
                </Tooltip>

                <div style={{ marginTop: 25 }} />
                <CurrencyInput required onError={(error, msg) => { this.setState({ inputError: error }) }} label={'Desconto (R$)'} onChange={(values) => { const { formattedValue, value } = values; this.setState({ addSaleData: { ...this.state.addSaleData, discount: value * 100 } }); }} value={this.state.addSaleData.discount > 0 ? this.state.addSaleData.discount / 100 : this.state.addSaleData.discount} />

                <h2 style={{ textAlign: 'left', marginTop: 25, color: Colors.success }}>Valor Bruto: +{CurrencyHelper.centsToMoney(this.state.addSaleData.value)}</h2>
                <h2 style={{ textAlign: 'left', marginTop: 10, color: Colors.error }}>Desconto: -{CurrencyHelper.centsToMoney(this.state.addSaleData.discount)}</h2>
                <h2 style={{ textAlign: 'left', marginTop: 10, color: Colors.primary }}>Valor da Venda: {CurrencyHelper.centsToMoney(this.state.addSaleData.value - this.state.addSaleData.discount)}</h2>
            </div>
        );
    }

    renderPaymenOptions(paymentOptions) {
        if (!paymentOptions) paymentOptions = this.state.paymentOptions;

        return (
            <div>
                <ul style={styles.ticketCardsContainer}>
                    {paymentOptions.map(paymentOption =>
                        <li
                            onClick={() => { this.setState({ addSaleData: { ...this.state.addSaleData, payment_method: paymentOption.key } }) }}
                            style={{ color: Colors.dark, boxShadow: `0px 0px 2px 0px ${this.state.addSaleData.payment_method === paymentOption.key ? Colors.primary : `rgba(34,34,34,0.46)`}`, ...styles.paymentMethodWrapper }}>
                            {paymentOption.icon}
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {this.state.addSaleData.payment_method === paymentOption.key ? <CheckIcon style={{ marginRight: 4, color: Colors.primary }} /> : null}
                                {paymentOption.label}
                            </div>
                            {this.state.addSaleData.payment_method === 'ticket' && paymentOption.key === 'ticket' ?
                                <MuiPickersUtilsProvider locale={brLocale} utils={DateFnsUtils}>
                                    <KeyboardDateTimePicker
                                        style={{ width: '80%', marginTop: 15 }}
                                        invalidDateMessage={false}
                                        format={'dd/MM/yyyy HH:mm'}
                                        autoOk={true}
                                        label="Data Limite para Pagamento"
                                        cancelLabel={'Cancelar'}
                                        okLabel={'Confirmar'}
                                        onChange={(v) => { this.setState({ end: v }) }}
                                        minDate={new Date()}
                                        value={this.state.end || null}
                                    />
                                </MuiPickersUtilsProvider>
                                : null}
                        </li>
                    )}
                </ul>
                {this.state.openTickets && this.state.openTickets.open > 0 ?
                    <div style={{ color: Colors.danger, display: 'flex', flexDirection: 'row', fontWeight: 'bold', marginBottom: 10, width: '100%', textAlign: 'center', fontSize: 22 }}>
                        <InfoRoundedIcon style={{ marginRight: 8, fontSize: 28 }} />
                        <div>{`Esse cliente já possui ${this.state.openTickets.open} comandas em aberto.`}</div>
                    </div>
                    : null}
                {this.state.openTickets && this.state.openTickets.late > 0 ?
                    <div style={{ color: Colors.error, display: 'flex', flexDirection: 'row', fontWeight: 'bold', marginBottom: 10, width: '100%', textAlign: 'center', fontSize: 22 }}>
                        <InfoRoundedIcon style={{ marginRight: 8, fontSize: 28 }} />
                        <div>{`Esse cliente tem ${this.state.openTickets.late} comandas vencidas e não pagas.`}</div>
                    </div>
                    : null}
            </div>
        );
    }

    renderOverview() {
        if (this.state.addSaleData) {
            return (
                <div>
                    <div style={{ marginBottom: 50, width: '100%', height: 400, overflowY: 'scroll', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 50 }}>
                        <h2 style={{ textAlign: 'center' }}>Revise os dados da venda.</h2>
                        <p style={{ textAlign: 'center', fontSize: 16 }}><b>Cliente:</b> {this.state.addSaleData.name}</p>
                        <p style={{ textAlign: 'center', fontSize: 16 }}><b>Produtos:</b> {this.state.addSaleData.items.map(item => `${item.title} (${item.quantity}), `)}</p>
                        <p style={{ textAlign: 'center', fontSize: 16 }}><b>Valor:</b> {CurrencyHelper.centsToMoney(this.state.addSaleData.value - this.state.addSaleData.discount)}</p>
                        <p style={{ textAlign: 'center', fontSize: 16 }}><b>Método de pagamento:</b> {(this.state.paymentOptions.find(opt => opt.key === this.state.addSaleData.payment_method)).label}</p>
                        {this.state.addSaleData.payment_method === 'ticket' ? <p style={{ textAlign: 'center', fontSize: 16 }}><b>Cliente pode pagar comanda até:</b> {moment(this.state.end).calendar()}</p> : null}
                        <p style={{ textAlign: 'center', fontWeight: 'light', fontSize: 10 }}>O ACE não se responsabiliza por esta transação monetária, o PDV do ACE apenas resgitra os dados para fins de controle financeiro.</p>
                    </div>
                </div>
            );
        }
    }

    renderFinish() {
        if (this.state.addSaleData) {
            return (
                <div>
                    <div style={{ marginBottom: 50, width: '100%', height: 400, overflowY: 'scroll', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 50 }}>
                        <CheckIcon style={{ textAlign: 'center', fontSize: 200, color: Colors.success }} />
                        <h1 style={{ textAlign: 'center' }}>Sucesso!<br />Venda realizada.</h1>
                    </div>
                </div>
            );
        }
    }

    salesModal() {
        if (this.state.addSaleModal) {
            return (
                <div>
                    <Stepper style={{ width: '100%' }} activeStep={this.state.addSaleData.step} alternativeLabel>
                        {this.state.addSaleData.steps.map((label, key) => (
                            <Step key={label}>
                                <StepLabel icon={this.renderIcon(key)}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    {this.state.addSaleData.step === 0 && this.renderClientSelection()}
                    {this.state.addSaleData.step === 1 && this.renderProductSelection()}
                    {this.state.addSaleData.step === 2 && this.renderPaymenOptions()}
                    {this.state.addSaleData.step === 3 && this.renderOverview()}
                    {this.state.addSaleData.step === 4 && this.renderFinish()}

                    <div style={{ alignSelf: 'center', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', paddingTop: 50 }}>
                        <DefaultButton leftIcon={<NavigateBeforeIcon />} onClick={() => { this.handleBack() }} color={Colors.secondaryButton} textColor={Colors.dark} loading={this.state.loadingModal} width={'48%'} title={'Voltar'} disabled={this.state.addSaleData.step === 0 || this.state.addSaleData.step === this.state.addSaleData.steps.length - 1} />
                        <DefaultButton rightIcon={this.state.addSaleData.step === this.state.addSaleData.steps.length - 1 ? <CheckIcon style={{ marginLeft: 3 }} /> : <NavigateNextIcon />} onClick={() => { this.handleNext() }} color={Colors.primary} loading={this.state.loadingModal} width={'48%'} title={this.state.addSaleData.step === this.state.addSaleData.steps.length - 1 ? 'Finalizar' : 'Avançar'} />
                    </div>
                </div>
            )
        }
    }

    cashierModal() {
        if (this.state.cashierModal) {
            return (
                <div>
                    <CurrencyInput label={'Valor em Caixa'} onChange={(values) => { const { formattedValue, value } = values; this.setState({ cashierAvailableMoney: formattedValue, rawCashierAvailableMoney: value }) }} value={this.state.cashierAvailableMoney} />
                    <div style={{ alignSelf: 'center', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', paddingTop: 50 }}>
                        <DefaultButton leftIcon={<CheckIcon />} onClick={() => { this.saveCashierOperation() }} color={Colors.primary} loading={this.state.loadingModal} width={'100%'} title={`Confirmar Operação`} />
                    </div>
                </div>
            )
        }
    }

    cashierWithdrawModal() {
        if (this.state.cashierWithdrawModal) {
            return (
                <div>
                    <p style={{ color: Colors.success, fontWeight: 'bold', fontSize: 20 }}>{`Valor em Caixa: ${CurrencyHelper.centsToMoney(this.state.rawCashierAvailableMoney * 100)}`}</p>
                    <CurrencyInput label={'Valor'} onChange={(values) => { const { formattedValue, value } = values; this.setState({ cashierWithdraw: formattedValue, rawCashierWithdraw: value }) }} value={this.state.cashierWithdraw} />
                    <div style={{ alignSelf: 'center', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', paddingTop: 50 }}>
                        <DefaultButton leftIcon={<CheckIcon />} onClick={() => { this.withdrawFromCashier() }} color={Colors.primary} loading={this.state.loadingModal} width={'100%'} title={`Confirmar Operação`} />
                    </div>
                </div>
            )
        }
    }

    dynamicSearch = async (text) => {
        this.setState({ search: text });

        const term = text;
        const minChars = 3;

        if (term == ``) {
            this.setState({ search: term });
            this.getDocs();
        }

        if (term.length < minChars) {
            this.setState({ isTyping: false });
            return;
        }

        this.setState({ isTyping: true });

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        const that = this;

        this.setState({
            typingTimeout: setTimeout(async () => {
                that.setState({ isTyping: false });
                that.search();
            }, 1000)
        });
    }

    search = () => {
        this.getDocs();
    }

    async handleMonthChange(advance) {
        let paginationStart = this.state.paginationStart, paginationEnd = this.state.paginationEnd;

        if (advance) {
            paginationStart = moment(paginationStart).add(1, 'month').startOf('month');
            paginationEnd = moment(paginationEnd).add(1, 'month').endOf('month');
        } else {
            paginationStart = moment(paginationStart).subtract(1, 'month').startOf('month');
            paginationEnd = moment(paginationEnd).subtract(1, 'month').endOf('month');
        }

        await this.setState({ paginationStart, paginationEnd });
        await this.getDocs();
    }

    renderMonthPicker() {
        return (
            <div style={{ backgroundColor: '#fff', width: 200, borderBottomWidth: .5, borderBottomColor: Colors.contrastColor, justifyContent: 'space-evenly', display: 'flex', flexDirection: 'row', }}>
                <IconButton style={{ height: 64, width: 64, color: Colors.primary }} onClick={() => { this.handleMonthChange(false) }} ><NavigateBeforeIcon /></IconButton>
                {this.state.reloading ? <DefaultLoader size={20} color={Colors.formLabel} css={{ display: 'flex', marginTop: 0, marginRight: 10, justifyContent: 'center', alignItems: 'center' }} /> : null}
                <h2 style={{ fontSize: 20, fontWeight: 'bold', color: Colors.formLabel }}>{moment(this.state.paginationStart).format('MMMM/YY')}</h2>
                <IconButton style={{ height: 64, width: 64, color: Colors.primary }} onClick={() => { this.handleMonthChange(true) }} ><NavigateNextIcon /></IconButton>
            </div>
        )
    }

    renderSearch() {
        return (
            <div style={styles.searchContainer}>
                {this.state.reloading ? <DefaultLoader size={28} color={Colors.formLabel} css={{ display: 'flex', marginTop: 5, marginRight: 10, justifyContent: 'center', alignItems: 'center' }} /> : <div style={{ display: 'flex', height: '100%', justifyContent: 'center', marginRight: 5 }}><SearchIcon style={{ marginTop: 25, fontSize: 28, color: Colors.formLabel }} /></div>}
                <DefaultInput label={'Busque por usuários...'} type={'text'} value={this.state.search} onChange={(text) => { this.dynamicSearch(text) }} />
            </div>
        );
    }

    selectElement = (element, stateField) => {
        let state = this.state;

        if (state[stateField].includes(element)) {
            const index = state[stateField].indexOf(element);
            if (index > -1) state[stateField].splice(index, 1);
        } else {
            state[stateField].push(element);
        }

        this.setState(state);

        this.getDocs();
    }

    renderStatuses = () => {
        return this.state.statuses.map(type => (
            <Tooltip title={`Filtrar comandas por ${type.title}`}>
                <div style={{ ...styles.typeSelector, border: `2px solid ${type.color}`, color: this.state.selectedStatuses.includes(type.type) ? `#fff` : Colors.formLabel, backgroundColor: this.state.selectedStatuses.includes(type.type) ? type.color : `#fafafa` }} onClick={() => { this.selectElement(type.type, `selectedStatuses`) }}>
                    {type.title.toUpperCase()}
                </div>
            </Tooltip>

        ));
    }

    async handleCashierModal() {

        this.setState({ loadingModal: true, cashierModal: true });

        await this.getCashierDocs();
        await this.getCashierMoneyFromOperation();

        this.setState({ loadingModal: false });
    }

    async handleCashierWithdrawModal() {

        this.setState({ loadingModal: true, cashierWithdrawModal: true });

        await this.getCashierDocs();
        await this.getCashierMoneyFromOperation();

        this.setState({ loadingModal: false });
    }

    renderCashier() {

        let lastOperation = this.state.cashierLastOperation;

        return (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <DefaultButton loading={this.state.reloading} color={lastOperation.operation === 'close' ? Colors.success : Colors.error} leftIcon={lastOperation.operation === 'close' ? <AttachMoneyIcon /> : <MoneyOffIcon />} onClick={() => { this.handleCashierModal() }} title={lastOperation.operation === 'close' ? 'Abrir Caixa' : 'Fechar Caixa'} />
                <div style={{ marginRight: 8 }} />
                {lastOperation.operation === 'open' ? <DefaultButton loading={this.state.reloading} color={Colors.danger} leftIcon={<CallReceivedIcon />} onClick={() => { this.handleCashierWithdrawModal() }} title={'Retirar Valor'} /> : null}
            </div>
        )
    }

    render() {
        return this.state.loading ? <DefaultLoader /> : (
            <div style={styles.container}>
                <HeaderActionsWrapper style={styles.headerButtons}>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <DefaultButton loading={this.state.reloading} leftIcon={<div style={{ display: 'flex', flexDirection: 'row' }}><ReceiptIcon /> <AddIcon style={{ fontSize: 16 }} /></div>} onClick={() => { this.setState({ addSaleModal: true }) }} title={'Nova Venda'} />
                        <div style={{ marginLeft: 8 }} />
                        {this.renderCashier()}
                    </div>
                    {this.renderMonthPicker()}
                    {this.renderSearch()}
                </HeaderActionsWrapper>
                <div style={styles.viewWrapper}>
                    <div style={styles.ticketWrapper}>
                        {this.renderTickets()}
                    </div>
                    <div style={styles.kanbanColumn}>
                        {this.renderTodaysSales()}
                    </div>
                </div>
                <DefaultModal loading={this.state.loadingModal} content={this.salesModal()} title={'Nova Venda'} onClose={() => {
                    this.setState({
                        addSaleModal: false,
                        end: moment().add(1, 'day').toDate(),
                        openTickets: {},
                        addSaleData: {
                            ...this.state.addSaleData,
                            step: 0,
                            id_user: '',
                            items: [],
                            payment_method: '',
                            value: 0,
                            discount: 0,
                            name: '',
                            email: '',
                            phone: '',
                            cpf: '',
                            zipcode: '',
                            street: '',
                            number: '',
                            neighbourhood: '',
                            complement: '',
                        }
                    })
                }} open={this.state.addSaleModal} width={window.screen.width < 1360 ? '99%' : window.screen.width - (window.screen.width * 0.3)} />
                <DefaultModal loading={this.state.loadingModal} content={this.cashierModal()} title={this.state.cashierLastOperation.operation === 'close' ? 'Abrir Caixa' : 'Fechar Caixa'} onClose={() => { this.setState({ cashierModal: false }) }} open={this.state.cashierModal} />
                <DefaultModal loading={this.state.loadingModal} content={this.cashierWithdrawModal()} title={'Retirar Valor'} onClose={() => { this.setState({ cashierWithdrawModal: false }) }} open={this.state.cashierWithdrawModal} />
            </div>
        );
    }
}

const styles = {
    container: {
        padding: 25,
        maxHeight: window.screen.width < 1360 ? window.screen.height : window.innerHeight,
        heigth: `100%`,
        display: `flex`,
        flexDirection: `column`,
    },
    headerButtons: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: window.screen.width < 1360 ? 'left' : 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white',
        padding: 15,
        boxShadow: 'rgba(50, 50, 50, 0.1) 1px 1px 10px 0px',
        borderRadius: 5
    },
    viewWrapper: {
        display: 'flex',
        paddingTop: 20,
        flexDirection: window.screen.width < 1360 ? 'column' : 'row',
        justifyContent: 'space-between',
        maxHeight: window.screen.width < 1360 ? '50%' : window.innerHeight - (223),
        maxHeight: window.screen.width < 1360 ? '50%' : window.innerHeight - (223),
    },
    ticketWrapper: {
        width: window.screen.width < 1360 ? '100%' : '74%',
        borderRadius: 10,
        minHeight: window.screen.width < 1360 ? '50%' : window.innerHeight - (223),
        maxHeight: window.screen.width < 1360 ? '50%' : window.innerHeight - (223),
        backgroundColor: 'blue',
        backgroundColor: `rgb(244, 245, 247)`
    },
    kanbanColumn: {
        marginTop: window.screen.width < 1360 ? 20 : 0,
        width: window.screen.width < 1360 ? '100%' : '25%',
        minHeight: window.screen.width < 1360 ? '50%' : window.innerHeight - (223),
        maxHeight: window.screen.width < 1360 ? '50%' : window.innerHeight - (223),
        borderRadius: 10,
        marginBottom: 10,
        flexDirection: `column`,
        backgroundColor: `rgb(244, 245, 247)`
    },
    kanbanTitleContainer: {
        display: `flex`,
        flexDirection: `row`,
        justifyContent: 'space-between',
        height: 32,
        padding: 13,
        width: `100%`
    },
    kanbanTitle: {
        display: `flex`,
        flexDirection: `row`,
        textAlign: `left`,
        fontWeight: `bold`,
        fontSize: 13
    },
    kanbanCardsContainer: {
        overflowY: `auto`,
        width: `100%`,
        maxHeight: window.screen.width < 1360 ? window.screen.height - (440 + 32) : window.innerHeight - (223 + 32),
        paddingLeft: 10,
        paddingBottom: 10,
        paddingRight: 10
    },
    ticketCardsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: 0,
        listStyleType: 'none',
        paddingInlineStart: 0
    },
    clientSelectionText: {
        color: `white`,
        fontSize: 12,
        paddingLeft: 5,
        paddingRight: 5,
        borderRadius: 5,
        marginLeft: 5,
        maxWidth: 100
    },
    paymentMethodWrapper: {
        display: `flex`,
        flexDirection: 'column',
        margin: 10,
        cursor: `pointer`,
        backgroundColor: `#fff`,
        fontSize: 20,
        justifyContent: 'center',
        alignItems: 'center',
        height: 200,
        width: 200,
        flexGrow: 1,
        marginTop: 5,
        borderRadius: 5,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 5,
        paddingBottom: 5
    },
    paymentIcon: {
        color: Colors.primary,
        fontSize: 64,
        marginBottom: 10
    },
    searchContainer: {
        display: `flex`,
        justifyContent: 'flex-end',
        width: window.screen.width < 1360 ? '95%' : '20%',
        marginTop: 5,
        marginBottom: 5,
        flexDirection: 'row'
    },
    typeSelector: {
        cursor: `pointer`,
        marginRight: 6,
        minHeight: `auto`,
        border: `2px solid ${Colors.primary}`,
        maxHeight: 18,
        textAlign: `center`,
        justifyContent: `center`,
        paddingLeft: 8,
        paddingRight: 8,
        fontSize: 12,
        fontWeight: 'bold',
        borderRadius: 15
    },
}